import { render } from "./BlFormFieldPlace.vue?vue&type=template&id=115fe713&scoped=true"
import script from "./BlFormFieldPlace.vue?vue&type=script&lang=js"
export * from "./BlFormFieldPlace.vue?vue&type=script&lang=js"

import "./BlFormFieldPlace.vue?vue&type=style&index=0&id=115fe713&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115fe713"]])

export default __exports__